import { FC, useContext, useEffect } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import ScreenHeader from '../ScreenHeader/ScreenHeader';
import { Box, Button, Link, useTheme } from '@mui/material';
import { ELinks, EMixpanelEvent } from '../../util/constants';
import mixpanel from 'mixpanel-browser';
import { useHistory } from 'react-router-dom';
import { IconRemoveUser, IconRemoveUserOutlined } from '../../icons/Icons';

const FacebookWarning: FC = () => {
    const { language, returnUrlParameter, coBranding } = useContext(GlobalContext);
    const history = useHistory();
    const theme = useTheme();

    const handleFacebookLogin = () => {
        const facebookLoginLink = returnUrlParameter
            ? `${ELinks.loginFacebook}&${returnUrlParameter}`
            : `${ELinks.loginFacebook}`;
        mixpanel.track(EMixpanelEvent.actionStart, { key: 'deprecate_facebook' });
        window.location.assign(facebookLoginLink);
    };

    const handleGoBack = () => {
        history.goBack();
    };

    useEffect(() => {
        mixpanel.track(EMixpanelEvent.viewed, { key: 'deprecate_facebook' });
    }, []);

    return (
        <PageLayoutV2>
            <Box sx={{ my: 2, textAlign: { lg: 'center' } }}>
                {coBranding.brandColor ? (
                    <IconRemoveUserOutlined fillColor={theme.palette.primary.main} />
                ) : (
                    <IconRemoveUser />
                )}
            </Box>
            <ScreenHeader
                title={language.deprecateFacebook.warning.title}
                desc={language.deprecateFacebook.warning.desc}
                size="large"
            />
            <Button
                component={'button'}
                variant="contained"
                size="large"
                onClick={handleFacebookLogin}
                fullWidth
                sx={{ mt: 2, mb: 3 }}
            >
                {language.deprecateFacebook.warning.cta}
            </Button>
            <Link component={'button'} onClick={handleGoBack} sx={{ typography: 'subtitle2', mb: 2 }}>
                {language.deprecateFacebook.warning.back}
            </Link>
        </PageLayoutV2>
    );
};

export default FacebookWarning;
